import React, {Fragment} from "react";
import styled from "styled-components";
import {media} from "assets/css/media";
import {useSelector} from "react-redux";
import {isAuthedSelector} from "modules/selectors";
import {IMenuItem, MenuItemType} from "modules/types";
import externalIcon from "assets/img/icons/external.png";
import {MenuItemDesktop, MenuItemDesktopExternal} from "components/Navigation/items/MenuItemDesktop";
import {SignUp} from "components/Navigation/items/SignUp";
import {GameSettingsUtils} from "modules/utils/secret";
import {partial} from "lodash";

const Wrapper = styled.div`
	display: flex;
	@media (max-width: ${media.mobile}) {
		display: none;
	}
`;
interface IProps {
	menuItems: IMenuItem[];
	onLinkClick: (link: string) => void;
}

export const DesktopMenu: React.FC<IProps> = ({menuItems, onLinkClick}) => {
	const isAuthed = useSelector(isAuthedSelector);
	const isHideItem = (items: IMenuItem) => (!isAuthed && items.isAuthed) || !items.link;

	const isActiveGame = GameSettingsUtils.IS_ENABLED_SESSION;
	console.log(isActiveGame);
	return isActiveGame ? (
		<Wrapper>
			{menuItems.map((item) => {
				return (
					<Fragment key={item.label}>
						{
							{
								[MenuItemType.Link]: !!item.link && (
									<MenuItemDesktop
										$isHideItem={isHideItem(item)}
										to={item.link}
										onClick={partial(onLinkClick, item.link)}
									>
										{window.getTranslations(item.label)}
									</MenuItemDesktop>
								),
								[MenuItemType.External]: !!item.link && (
									<MenuItemDesktopExternal
										href={item.link}
										$isHideItem={isHideItem(item)}
										target={"_blank"}
										onClick={partial(onLinkClick, item.link)}
										rel="noopener noreferrer"
									>
										{window.getTranslations(item.label)}
										<img src={externalIcon} alt="External icon" />
									</MenuItemDesktopExternal>
								),
								[MenuItemType.SignUp]: !isAuthed && <SignUp item={item} />,
							}[item.menuItemType]
						}
					</Fragment>
				);
			})}
		</Wrapper>
	) : null;
};
